'use client';
import { useAuth } from '@/hooks/useAuth';
import Link from 'next/link';
import { useState } from 'react';
import { MenuIcon } from './icons/MenuIcon';
import { XIcon } from './icons/XIcon';
import { UserMenu } from './user-menu';
export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user } = useAuth();
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const navLinks = [
    { label: 'ABOUT', href: '/#about' },
    { label: 'EXPERIENCE', href: '/#experience' },
    { label: 'SKILLS', href: '/#skills' },
    // { label: 'GITHUB', href: '/#github-stats' },
    // { label: 'SERVICES', href: '/#services' },
    { label: 'PROJECTS', href: '/#projects' },
    { label: 'EDUCATION', href: '/#education' },
    { label: 'BLOGS', href: 'https://www.codescrolls.site/blog' },
  ];
  return (
    <nav className='bg-transparent py-5' role='navigation' aria-label='Main navigation'>
      <div className='flex items-center justify-between'>
        <Link
          href='/'
          className='text-3xl font-bold text-[#16f2b3] transition-colors duration-300 hover:text-pink-600'
        >
          Praveen Singh
        </Link>
        <div className='flex items-center space-x-6'>
          <ul className='hidden space-x-6 md:flex'>
            {navLinks.map(({ label, href }) => (
              <li key={href}>
                <Link
                  href={href}
                  className='text-sm text-white transition-colors duration-300 hover:text-pink-600'
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
          {user && <UserMenu user={user} />}
          <button
            className='text-white md:hidden'
            onClick={toggleMenu}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            {menuOpen ? <XIcon size={28} /> : <MenuIcon size={28} />}
          </button>
        </div>
      </div>
      {menuOpen && (
        <ul className='mt-4 flex flex-col space-y-3 md:hidden'>
          {navLinks.map(({ label, href }) => (
            <li key={href}>
              <Link
                href={href}
                onClick={() => setMenuOpen(false)}
                className='block text-sm text-white transition-colors duration-300 hover:text-pink-600'
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}
